export default __webpack_public_path__ + "static/media/disruption.5955dbf8.svg";